// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__yjQiU","label":"CategoryService_label__wcPO8","location":"CategoryService_location__3ZDFS"};